export default "__VITE_ASSET__BEhSO3j1__"